module.exports = __webpack_public_path__ + "static/img/addIcon.9754886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/addIcon.png
// module id = Ugi4
// module chunks = 1